/**
 * The Traffic link dialog rules (link-dialog-provider, traffic-dialog-payload)
 * bound to the trackers this deployment has enabled — Tres Commas links open the
 * dialog only where its tile exists.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useMemo } from 'react';

import { useEnabledTrackers } from '@/features/trackers/useEnabledTrackers';
import type { TabGroup } from '@/pages/admin/SmswiserCampaignDetailPage/types';

import type { StatsCampaign } from './build-tab-groups';
import { campaignLinkEditable, groupLinkEditable } from './link-dialog-provider';
import { trafficDialogPayloadFor, type TrafficDialogState } from './traffic-dialog-payload';

export function useTrafficLinkRules() {
  const enabled = useEnabledTrackers();
  return useMemo(
    () => ({
      campaignEditable: (campaign: { trafficProvider?: string | null }) =>
        campaignLinkEditable(campaign, enabled),
      groupEditable: (group: TabGroup | undefined) => groupLinkEditable(group, enabled),
      payloadFor: (dialog: TrafficDialogState | null, groups: TabGroup[], campaigns: StatsCampaign[]) =>
        trafficDialogPayloadFor(dialog, groups, campaigns, enabled),
    }),
    [enabled],
  );
}
